import classnames from 'classnames'
import { ReactNode } from 'react'

// Domains
import { ContentfulSizeChartSection } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

// Styles
import styles from '../sizeChart.module.scss'

interface TableWrapperProps {
  children: ReactNode
  className: string
  index: number
}

const TableWrapper = ({ children, className, index }: TableWrapperProps) =>
  index === 0 ? <thead className={className}>{children}</thead> : <tbody className={className}>{children}</tbody>

interface SizeChartContentProps {
  sizeChartSection: ContentfulSizeChartSection
}

const SizeChartContent = (props: SizeChartContentProps) => {
  return (
    <>
      <table className={styles.container__body}>
        {props.sizeChartSection?.items?.map((item, index) => {
          const values = item.values.split(',') || []
          return (
            <TableWrapper
              className={classnames(styles.container__body__row, index === 0 && styles.container__body__row__firstRow)}
              key={item.key}
              index={index}
            >
              <th className={styles.container__body__row__key}>{index !== 0 && item.key}</th>
              {values.map((value, i) => {
                return (
                  <td
                    className={classnames(
                      styles.container__body__row__value,
                      index === 0 && styles.container__body__row__value__header,
                      i % 2 !== 0 && styles.bgColor,
                    )}
                    key={`${value}__${i}`}
                  >
                    {value}
                  </td>
                )
              })}
            </TableWrapper>
          )
        })}
      </table>
    </>
  )
}

export default SizeChartContent
